module.exports = __webpack_public_path__ + "static/fonts/NanumGothic_seB.352fb4b.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/NanumGothic_seB.eot
// module id = NaTV
// module chunks = 241